import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import {Observable} from 'rxjs';
import {PermissionsService} from './permissions.service';
import {AsignUserRoleService} from './asign-user-role.service';
import {LocalStorageSettingsService} from './local-storage-settings.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {CommonService} from './common.service';
import {CommonPermissionService} from './common-permission.service';
import { constants } from "src/app/shared/common/contants";


@Injectable({
  providedIn: 'root'
})
/*
Author:Ravi G
Date:28-06-2022
*/
export class AuthGuard  {
  permissions: any;

  constructor(private permissionService: PermissionsService,
              private router: Router,
              private asignUserRoleService: AsignUserRoleService,
              private localStorage: LocalStorageSettingsService,
              private spinner: NgxUiLoaderService,
              private snackBar: MatSnackBar,
              private commonService: CommonService,
              private commonPermissionService: CommonPermissionService,
              private constants: constants) {
  }

  /*
  @Author:Ravi G
  @Date:28-06-2022
  @Description check is user have access to current page
*/
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return new Promise(async data => {

      var userName = localStorage.getItem('AuthUsername');

      console.log(userName);

      let userData: any = await this.commonService.retrieveSingleRecordService('users', 'username', userName);

      console.log(userData);

      let userId = userData[0].userid;
      this.asignUserRoleService.reteriveuserRoleByTenantIdAndUserId(userId).subscribe(response => {
        if (response == null) {
          if (state.url.split('/').pop() == 'home') {
            data(true)
          }
          this.snackBar.open(this.constants.userNoPermissionAccessScreen, 'OK', {duration: 5000});


        } else if (response.error === true) {

          console.log(response);

          this.spinner.stop();

          this.snackBar.open(response.statusMessage, 'OK', {duration: 5000});
          return response;

        } else {
          this.spinner.stop();
          console.log(response);
          // @ts-ignore
          if (state.url.split('/').pop() == 'home') {
            data(true);
          } else {

            this.commonPermissionService.retrieveWeb(response).subscribe(response => {
              console.log(response);
              var permissionsLength = response[0];
              this.permissions = response[1];
              console.log(this.permissions);
              //In children array inside arrays are created four json objects are storing into one array.
              var childrenObj = [];
              for (var i = 0; i < this.permissions.length; i++) {
                //It will execute if child length is greater then zero
                if (this.permissions[i].child.length > 0) {
                  console.log(this.permissions[i].child);
                  //Storing child into childrenTemp
                  var childrenTemp = this.permissions[i].child;
                  console.log(childrenTemp);
                  //Clearning the child
                  this.permissions[i].child = [];
                  console.log(this.permissions[i].child);

                  var childrenAnother = [];
                  var k = -1;
                  for (var j = 0; j < childrenTemp.length; j++) {
                    k = k + 1;
                    childrenObj.push(childrenTemp[j]);
                    //It is changed by nikhil 11-12-2019
                    //Changed the value from 3 to 5
                    while (k == 5) {
                      //Four json objects storing into one array
                      childrenAnother.push(childrenObj);
                      k = -1;

                    }
                  }
                  childrenAnother.push(childrenObj);
                  this.permissions[i].child = childrenAnother;


                }
              }
              var tableName = state.url.split('tableName=').pop();
              tableName = tableName.substr(0, tableName.indexOf('&'));

              var isUrl = false;
              /*
              @Author:Chandra R
              @Date:02-01-2025
              @Description :Updated code it checks  if it doesn't match, then checks the second-to-last segment
             */
              /*
              @Modified By : Rahul Vk 
              @Date:24-11-2025
              @Description :Updated code to check the url path recursively until match 
             */
                // Split the URL into all parts
                const urlSegments = state.url.split('/').filter(seg => seg.trim() !== '');
                // debugger;

                for (let i = 0; i < childrenObj.length; i++) {

                  // Check if ANY segment in the URL path matches urlPath
                  const isSegmentMatch = urlSegments.some(seg => seg === childrenObj[i].urlPath);

                  // Also check tableName if applicable
                  const isTableNameMatch = tableName && tableName.match(childrenObj[i].urlPath);

                  if (isSegmentMatch || isTableNameMatch) {
                    data(true);
                    isUrl = true;
                    break;        // stop checking when matched
                  }
                }
              
              if (!isUrl){
                this.snackBar.open("You are not authorised to access that page. You are being forwarded to the home page.", "OK", { duration: 7000 });
                // this.router.navigate(['']);
                data(false)
                this.router.navigate(['']);
              }

              this.spinner.stop();
            });

          }


        }
      });


    });


  }


}
